import React, { Component } from 'react';
import {
    Box,
    Typography,
    Button,
    Grid,
    Card,
    CardContent,
    CardMedia,
    TextField,
    IconButton,
    Switch,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Chip,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Badge,
    Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import InventoryIcon from '@mui/icons-material/Inventory';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LaunchIcon from '@mui/icons-material/Launch';
import CategoryIcon from '@mui/icons-material/Category';
import FilterListIcon from '@mui/icons-material/FilterList';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ClearIcon from '@mui/icons-material/Clear';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { apiUrl } from '../../comp/ApiUrl';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

class ListProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            selectedCategory: 'ALL',
            statusFilter: 'ALL', // ALL, VISIBLE, HIDDEN
            stockFilter: 'ALL',  // ALL, OUT_OF_STOCK, LOW_STOCK
            sortBy: 'NEWEST',    // NEWEST, PRICE_ASC, PRICE_DESC, NAME_ASC
            mobileCategoryOpen: false,
            drawerFilterOpen: false,
            data: [],
            categorias: [],
            options: {},
            deleteProduct: {},
        };
    }

    componentDidMount() {
        document.title = 'Gestão de Produtos';
        this.fetchProducts();
    }

    fetchProducts = () => {
        fetch(`${apiUrl}/produtos`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("userToken"),
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const produtos = data.produtos || [];
                const categorias = data.categorias || [];
                this.setState({
                    data: produtos,
                    categorias: categorias
                });
            })
            .catch((error) => {
                console.error("Erro ao buscar produtos e categorias", error);
                toast.error("Erro ao carregar lista de produtos.");
            });
    };

    handleSearchChange = (event) => {
        this.setState({ searchTerm: event.target.value });
    };

    handleCategorySelect = (categoryId) => {
        this.setState({
            selectedCategory: categoryId,
            mobileCategoryOpen: false
        });
    };

    handleVisibilityChange = (id) => {
        let novoStatusCatalog = false;

        this.setState((prevState) => {
            const listaAtualizada = prevState.data.map((product) => {
                if (product.id === id) {
                    novoStatusCatalog = !product.catalog;
                    return { ...product, catalog: novoStatusCatalog };
                }
                return product;
            });

            return { data: listaAtualizada };
        }, () => {
            fetch(`${apiUrl}/products/set/catalog`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: id,
                    catalog: novoStatusCatalog ? "Y" : "N"
                }),
            })
                .then(() => {
                    toast.success('Visibilidade alterada com sucesso!');
                })
                .catch((error) => {
                    console.error("Erro ao atualizar visibilidade:", error);
                    toast.error("Erro ao salvar alteração.");
                    this.setState((prevState) => ({
                        data: prevState.data.map((product) =>
                            product.id === id ? { ...product, catalog: !novoStatusCatalog } : product
                        )
                    }));
                });
        });
    };

    handleDeleteProduct = () => {
        const id = this.state.deleteProduct.id;
        fetch(`${apiUrl}/produtos/${id}`, {
            method: "DELETE",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
        }).then((response) => {
            if (response.status === 200 || response.ok) {
                toast.success("Produto excluído com sucesso!");
                this.setState((prevState) => ({
                    data: prevState.data.filter((product) => product.id !== id),
                    deleteProduct: {},
                }));
            } else {
                toast.error("Falha ao excluir o produto.");
            }
        }).catch(() => {
            toast.error("Erro na comunicação com o servidor.");
        });
    };

    clearAllFilters = () => {
        this.setState({
            searchTerm: '',
            selectedCategory: 'ALL',
            statusFilter: 'ALL',
            stockFilter: 'ALL',
            sortBy: 'NEWEST'
        });
    };

    calculateStats = () => {
        const { data } = this.state;
        const total = data.length;
        const ativos = data.filter(p => p.catalog).length;
        const ocultos = total - ativos;
        const estoqueBaixo = data.filter(p => (p.stock || 0) <= 2).length;

        return { total, ativos, ocultos, estoqueBaixo };
    };

    getFilteredAndSortedProducts = () => {
        const { data, searchTerm, selectedCategory, statusFilter, stockFilter, sortBy } = this.state;

        return data
            .filter((product) => {
                // Filtro de Busca por Texto
                const term = searchTerm.toLowerCase();
                const matchesSearch = product.name?.toLowerCase().includes(term) ||
                    (product.ean && product.ean.includes(term));

                // Filtro por Categoria
                const matchesCategory = selectedCategory === 'ALL' ||
                    product.categoria_id === selectedCategory ||
                    product.categoria === selectedCategory;

                // Filtro de Status Visível/Oculto
                const matchesStatus = statusFilter === 'ALL' ||
                    (statusFilter === 'VISIBLE' && product.catalog) ||
                    (statusFilter === 'HIDDEN' && !product.catalog);

                // Filtro de Estoque
                const stock = Number(product.stock) || 0;
                const matchesStock = stockFilter === 'ALL' ||
                    (stockFilter === 'OUT_OF_STOCK' && stock === 0) ||
                    (stockFilter === 'LOW_STOCK' && stock > 0 && stock <= 3);

                return matchesSearch && matchesCategory && matchesStatus && matchesStock;
            })
            .sort((a, b) => {
                if (sortBy === 'PRICE_ASC') return Number(a.price) - Number(b.price);
                if (sortBy === 'PRICE_DESC') return Number(b.price) - Number(a.price);
                if (sortBy === 'NAME_ASC') return a.name.localeCompare(b.name);
                if (sortBy === 'NEWEST') return new Date(b.created_at || 0) - new Date(a.created_at || 0);
                return 0;
            });
    };

    renderCategoryList = () => {
        const { categorias, selectedCategory, data } = this.state;

        return (
            <Paper variant="outlined" sx={{ borderRadius: 3, p: 1.5, backgroundColor: '#fff' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', px: 1, pb: 1.5, color: '#666', letterSpacing: 0.5 }}>
                    CATEGORIAS
                </Typography>

                <List component="nav" disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <ListItemButton
                        selected={selectedCategory === 'ALL'}
                        onClick={() => this.handleCategorySelect('ALL')}
                        sx={{
                            borderRadius: 2,
                            '&.Mui-selected': {
                                backgroundColor: '#f3f0ff',
                                color: '#6c5ce7',
                                fontWeight: 'bold',
                                '&:hover': { backgroundColor: '#e9e4ff' }
                            }
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 32, color: selectedCategory === 'ALL' ? '#6c5ce7' : 'inherit' }}>
                            <CategoryIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Todas" primaryTypographyProps={{ fontSize: '0.875rem' }} />
                        <Chip label={data.length} size="small" sx={{ height: 20, fontSize: '0.75rem', fontWeight: 'bold' }} />
                    </ListItemButton>

                    {categorias.map((cat) => {
                        const count = data.filter(p => p.categoria_id === cat.id || p.categoria === cat.nome).length;

                        return (
                            <ListItemButton
                                key={cat.id}
                                selected={selectedCategory === cat.id}
                                onClick={() => this.handleCategorySelect(cat.id)}
                                sx={{
                                    borderRadius: 2,
                                    '&.Mui-selected': {
                                        backgroundColor: '#f3f0ff',
                                        color: '#6c5ce7',
                                        fontWeight: 'bold',
                                        '&:hover': { backgroundColor: '#e9e4ff' }
                                    }
                                }}
                            >
                                <ListItemText
                                    primary={cat.nome}
                                    primaryTypographyProps={{ fontSize: '0.875rem' }}
                                />
                                <Chip label={count} size="small" variant="outlined" sx={{ height: 20, fontSize: '0.75rem' }} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </Paper>
        );
    };

    render() {
        const { searchTerm, selectedCategory, statusFilter, stockFilter, sortBy, mobileCategoryOpen, drawerFilterOpen } = this.state;
        const stats = this.calculateStats();
        const filteredProducts = this.getFilteredAndSortedProducts();
        const activeFiltersCount = (selectedCategory !== 'ALL' ? 1 : 0) + (statusFilter !== 'ALL' ? 1 : 0) + (stockFilter !== 'ALL' ? 1 : 0);

        return (
            <Box sx={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>

                {/* CABEÇALHO */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a1a', fontSize: { xs: '1.4rem', sm: '1.8rem' } }}>
                            Gerenciador
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Organize seu estoque, defina visibilidade e controle seus preços no catálogo
                        </Typography>
                    </Box>
                    <Button
                        component={Link}
                        to="novo"
                        variant="contained"
                        startIcon={<AddIcon />}
                        sx={{
                            backgroundColor: '#6c5ce7',
                            '&:hover': { backgroundColor: '#5b4bc4' },
                            borderRadius: 2.5,
                            px: 3,
                            py: 1,
                            textTransform: 'none',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 12px rgba(108, 92, 231, 0.25)'
                        }}
                    >
                        Cadastrar Produto
                    </Button>
                </Box>

                {/* RESUMO KPI / STATS */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ p: 1.5, backgroundColor: '#f3f0ff', borderRadius: 2.5, color: '#6c5ce7', display: 'flex' }}>
                                <InventoryIcon />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>{stats.total}</Typography>
                                <Typography variant="caption" color="textSecondary">Total Cadastrados</Typography>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ p: 1.5, backgroundColor: '#e8f5e9', borderRadius: 2.5, color: '#2e7d32', display: 'flex' }}>
                                <VisibilityIcon />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>{stats.ativos}</Typography>
                                <Typography variant="caption" color="textSecondary">Ativos no Catálogo</Typography>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ p: 1.5, backgroundColor: '#f5f5f5', borderRadius: 2.5, color: '#757575', display: 'flex' }}>
                                <VisibilityOffIcon />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>{stats.ocultos}</Typography>
                                <Typography variant="caption" color="textSecondary">Produtos Ocultos</Typography>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ p: 1.5, backgroundColor: '#fff3e0', borderRadius: 2.5, color: '#e65100', display: 'flex' }}>
                                <WarningAmberIcon />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>{stats.estoqueBaixo}</Typography>
                                <Typography variant="caption" color="textSecondary">Estoque Baixo/Zerado</Typography>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>

                {/* CONTROLES E PESQUISA */}
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 3, backgroundColor: '#fff' }}>
                    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>

                        <Button
                            variant="outlined"
                            startIcon={<FilterListIcon />}
                            onClick={() => this.setState({ mobileCategoryOpen: true })}
                            sx={{
                                display: { xs: 'flex', md: 'none' },
                                borderRadius: 2.5,
                                textTransform: 'none',
                                borderColor: '#e0e0e0',
                                color: '#333'
                            }}
                        >
                            Categorias
                        </Button>

                        <TextField
                            placeholder="Buscar por nome ou código EAN..."
                            value={searchTerm}
                            size="small"
                            onChange={this.handleSearchChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                                endAdornment: searchTerm && (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={() => this.setState({ searchTerm: '' })}>
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                flexGrow: 1,
                                minWidth: { xs: '100%', sm: '260px' },
                                '& .MuiOutlinedInput-root': { borderRadius: 2.5 }
                            }}
                        />

                        {/* SELECT RÁPIDO DE ORDENAÇÃO */}
                        <FormControl size="small" sx={{ minWidth: 160, display: { xs: 'none', sm: 'flex' } }}>
                            <InputLabel>Ordenar Por</InputLabel>
                            <Select
                                value={sortBy}
                                label="Ordenar Por"
                                onChange={(e) => this.setState({ sortBy: e.target.value })}
                                sx={{ borderRadius: 2.5 }}
                            >
                                <MenuItem value="NEWEST">Mais Recentes</MenuItem>
                                <MenuItem value="PRICE_ASC">Menor Preço</MenuItem>
                                <MenuItem value="PRICE_DESC">Maior Preço</MenuItem>
                                <MenuItem value="NAME_ASC">Nome (A-Z)</MenuItem>
                            </Select>
                        </FormControl>

                        {/* BOTÃO FILTROS AVANÇADOS */}
                        <Badge badgeContent={activeFiltersCount} color="primary">
                            <Button
                                variant="outlined"
                                startIcon={<TuneIcon />}
                                onClick={() => this.setState({ drawerFilterOpen: true })}
                                sx={{
                                    borderRadius: 2.5,
                                    textTransform: 'none',
                                    borderColor: '#e0e0e0',
                                    color: '#333',
                                    height: '40px'
                                }}
                            >
                                Filtros
                            </Button>
                        </Badge>
                    </Box>

                    {/* BADGES DE FILTROS ATIVOS */}
                    {(activeFiltersCount > 0 || searchTerm !== '') && (
                        <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                            <Typography variant="caption" color="textSecondary">Filtros Ativos:</Typography>
                            {selectedCategory !== 'ALL' && (
                                <Chip
                                    label={`Categoria ID: ${selectedCategory}`}
                                    size="small"
                                    onDelete={() => this.setState({ selectedCategory: 'ALL' })}
                                />
                            )}
                            {statusFilter !== 'ALL' && (
                                <Chip
                                    label={statusFilter === 'VISIBLE' ? 'Somente Visíveis' : 'Somente Ocultos'}
                                    size="small"
                                    onDelete={() => this.setState({ statusFilter: 'ALL' })}
                                />
                            )}
                            {stockFilter !== 'ALL' && (
                                <Chip
                                    label={stockFilter === 'OUT_OF_STOCK' ? 'Sem Estoque' : 'Estoque Baixo'}
                                    size="small"
                                    onDelete={() => this.setState({ stockFilter: 'ALL' })}
                                />
                            )}
                            <Button
                                size="small"
                                color="error"
                                onClick={this.clearAllFilters}
                                sx={{ fontSize: '0.75rem', textTransform: 'none' }}
                            >
                                Limpar Todos
                            </Button>
                        </Box>
                    )}
                </Paper>

                {/* LISTAGEM PRINCIPAL */}
                <Grid container spacing={3}>

                    {/* SIDEBAR CATEGORIAS (DESKTOP) */}
                    <Grid item size={{ md: 3, lg: 2.5 }} sx={{ display: { xs: 'none', md: 'block' } }}>
                        {this.renderCategoryList()}
                    </Grid>

                    {/* GRID DE PRODUTOS */}
                    <Grid item size={{ xs: 12, md: 9, lg: 9.5 }}>

                        {filteredProducts.length === 0 ? (
                            <Paper variant="outlined" sx={{ p: 5, textAlign: 'center', borderRadius: 4, backgroundColor: '#fff' }}>
                                <InventoryIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
                                <Typography variant="h6" color="textSecondary" gutterBottom>
                                    Nenhum produto encontrado
                                </Typography>
                                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                                    Tente ajustar seus termos de pesquisa ou os filtros selecionados.
                                </Typography>
                                <Button variant="outlined" onClick={this.clearAllFilters} sx={{ textTransform: 'none', borderRadius: 2 }}>
                                    Limpar Filtros
                                </Button>
                            </Paper>
                        ) : (
                            <Grid container spacing={2.5}>
                                {filteredProducts.map((product) => {
                                    const costNum = Number(product.custo) || 0;
                                    const priceNum = Number(product.price) || 0;
                                    const margin = priceNum > 0 ? (((priceNum - costNum) / priceNum) * 100).toFixed(0) : 0;
                                    const isLowStock = (product.stock || 0) <= 2;

                                    return (
                                        <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={product.id}>
                                            <Card
                                                variant="outlined"
                                                sx={{
                                                    borderRadius: 3.5,
                                                    overflow: 'hidden',
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',

                                                }}
                                            >
                                                {/* ÁREA DA IMAGEM E CAPA */}
                                                <Box sx={{ position: 'relative', pt: '75%', backgroundColor: '#f0f0f0' }}>
                                                    <CardMedia
                                                        component="img"
                                                        image={product.image_list && product.image_list[0] && product.image_list[0].name ? `${apiUrl}/static/${product.image_list[0].name}` : 'https://via.placeholder.com/300?text=Sem+Foto'}
                                                        alt={product.name}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />

                                                    {/* BADGE VISIBILIDADE / STATUS */}
                                                    <Box sx={{ position: 'absolute', top: 10, left: 10 }}>
                                                        <Chip
                                                            label={product.catalog ? 'Visível' : 'Oculto'}
                                                            size="small"
                                                            color={product.catalog ? 'success' : 'default'}
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                fontSize: '0.7rem',
                                                                backdropFilter: 'blur(4px)',
                                                                backgroundColor: product.catalog ? 'rgba(46, 125, 50, 0.9)' : 'rgba(97, 97, 97, 0.9)'
                                                            }}
                                                        />
                                                    </Box>

                                                    {/* BOTAO MAIS OPÇÕES */}
                                                    <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
                                                        <IconButton
                                                            aria-label="opções"
                                                            onClick={() => this.setState({ options: product })}
                                                            sx={{
                                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                                '&:hover': { backgroundColor: '#fff' },
                                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
                                                            }}
                                                            size="small"
                                                        >
                                                            <MoreVertIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>

                                                    {/* TAG ALERTA DE ESTOQUE BAIXO */}
                                                    {isLowStock && (
                                                        <Box sx={{ position: 'absolute', bottom: 8, left: 8 }}>
                                                            <Tooltip title="Atenção: Estoque limite atingido">
                                                                <Chip
                                                                    icon={<WarningAmberIcon style={{ color: '#fff', fontSize: 14 }} />}
                                                                    label={product.stock === 0 ? "Esgotado" : "Poucas un."}
                                                                    size="small"
                                                                    sx={{
                                                                        backgroundColor: product.stock === 0 ? 'rgba(211, 47, 47, 0.95)' : 'rgba(230, 81, 0, 0.95)',
                                                                        color: '#fff',
                                                                        fontSize: '0.7rem',
                                                                        fontWeight: 'bold'
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </Box>
                                                    )}
                                                </Box>

                                                {/* CONTEÚDO DO CARD */}
                                                <CardContent sx={{ p: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                                    <Typography
                                                        component={Link}
                                                        to={`${product.uuid}/basic`}
                                                        variant="subtitle2"
                                                        sx={{
                                                            fontWeight: 700,
                                                            lineHeight: 1.3,
                                                            mb: 1.5,
                                                            height: '2.6em',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            display: '-webkit-box',
                                                            '-webkit-line-clamp': 2,
                                                            '-webkit-box-orient': 'vertical',
                                                            textDecoration: 'none',
                                                            color: '#2d3436',
                                                            '&:hover': { color: '#6c5ce7' },
                                                        }}
                                                    >
                                                        {product.name}
                                                    </Typography>

                                                    <Box sx={{ mt: 'auto' }}>
                                                        {/* GRID DE PREÇO E ESTOQUE */}
                                                        <Grid container spacing={1} sx={{ mb: 1.5 }}>
                                                            <Grid item size={{ xs: 6 }}>
                                                                <Box sx={{ backgroundColor: '#f8f9fa', p: 1, borderRadius: 2, border: '1px solid #f0f0f0' }}>
                                                                    <Typography variant="caption" color="textSecondary" display="block" sx={{ fontSize: '0.65rem' }}>PREÇO</Typography>
                                                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                                                                        {priceNum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>

                                                            <Grid item size={{ xs: 6 }}>
                                                                <Box sx={{ backgroundColor: '#f8f9fa', p: 1, borderRadius: 2, border: '1px solid #f0f0f0' }}>
                                                                    <Typography variant="caption" color="textSecondary" display="block" sx={{ fontSize: '0.65rem' }}>ESTOQUE</Typography>
                                                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: product.stock === 0 ? '#d32f2f' : '#2d3436' }}>
                                                                        {product.stock || 0} un.
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>






                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                {/* DRAWER CATEGORIAS MOBILE */}
                <Drawer
                    anchor="left"
                    open={mobileCategoryOpen}
                    onClose={() => this.setState({ mobileCategoryOpen: false })}
                >
                    <Box sx={{ width: 280, p: 2 }}>
                        {this.renderCategoryList()}
                    </Box>
                </Drawer>

                {/* DRAWER FILTROS AVANÇADOS */}
                <Drawer
                    anchor="right"
                    open={drawerFilterOpen}
                    onClose={() => this.setState({ drawerFilterOpen: false })}
                >
                    <Box sx={{ width: { xs: 280, sm: 340 }, p: 3 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Filtros do Painel</Typography>
                            <IconButton onClick={() => this.setState({ drawerFilterOpen: false })}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                        <Divider sx={{ mb: 3 }} />

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            {/* STATUS DO CATÁLOGO */}
                            <FormControl fullWidth size="small">
                                <InputLabel>Status do Produto</InputLabel>
                                <Select
                                    value={statusFilter}
                                    label="Status do Produto"
                                    onChange={(e) => this.setState({ statusFilter: e.target.value })}
                                >
                                    <MenuItem value="ALL">Todos os Produtos</MenuItem>
                                    <MenuItem value="VISIBLE">Apenas Visíveis no Catálogo</MenuItem>
                                    <MenuItem value="HIDDEN">Apenas Ocultos</MenuItem>
                                </Select>
                            </FormControl>

                            {/* ESTOQUE */}
                            <FormControl fullWidth size="small">
                                <InputLabel>Situação do Estoque</InputLabel>
                                <Select
                                    value={stockFilter}
                                    label="Situação do Estoque"
                                    onChange={(e) => this.setState({ stockFilter: e.target.value })}
                                >
                                    <MenuItem value="ALL">Todos os Níveis</MenuItem>
                                    <MenuItem value="LOW_STOCK">Estoque Baixo ()</MenuItem>
                                    <MenuItem value="OUT_OF_STOCK">Sem Estoque (Esgotado)</MenuItem>
                                </Select>
                            </FormControl>

                            {/* ORDENAÇÃO */}
                            <FormControl fullWidth size="small">
                                <InputLabel>Ordenar Por</InputLabel>
                                <Select
                                    value={sortBy}
                                    label="Ordenar Por"
                                    onChange={(e) => this.setState({ sortBy: e.target.value })}
                                >
                                    <MenuItem value="NEWEST">Mais Recentes</MenuItem>
                                    <MenuItem value="PRICE_ASC">Menor Preço</MenuItem>
                                    <MenuItem value="PRICE_DESC">Maior Preço</MenuItem>
                                    <MenuItem value="NAME_ASC">Nome (A-Z)</MenuItem>
                                </Select>
                            </FormControl>

                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => this.setState({ drawerFilterOpen: false })}
                                sx={{ backgroundColor: '#6c5ce7', borderRadius: 2, textTransform: 'none', mt: 2 }}
                            >
                                Aplicar Filtros
                            </Button>

                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={this.clearAllFilters}
                                color="inherit"
                                sx={{ borderRadius: 2, textTransform: 'none' }}
                            >
                                Limpar Tudo
                            </Button>
                        </Box>
                    </Box>
                </Drawer>

                {/* DIALOG DE OPÇÕES RÁPIDAS DO PRODUTO */}
                <Dialog
                    open={Object.keys(this.state.options).length > 0}
                    onClose={() => this.setState({ options: {} })}
                    fullWidth
                    maxWidth="xs"
                    PaperProps={{ sx: { borderRadius: 3 } }}
                >
                    <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.1rem', pb: 1 }}>
                        {this.state.options.name}
                    </DialogTitle>
                    <DialogContent dividers>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: 1 }}>
                            <Button
                                startIcon={<EditIcon />}
                                component={Link}
                                to={`${this.state.options.uuid}/basic`}
                                fullWidth
                                variant="outlined"
                                color="primary"
                                sx={{ borderRadius: 2, justifyContent: 'flex-start', textTransform: 'none' }}
                            >
                                Editar Informações do Produto
                            </Button>
                            <Button
                                fullWidth
                                variant="outlined"
                                color="info"
                                startIcon={<LaunchIcon />}
                                sx={{ borderRadius: 2, justifyContent: 'flex-start', textTransform: 'none' }}
                                onClick={() => toast.info("Redirecionando para a loja...")}
                            >
                                Visualizar no Catálogo Online
                            </Button>
                            <Button
                                startIcon={<DeleteIcon />}
                                onClick={() => this.setState({ options: {}, deleteProduct: this.state.options })}
                                fullWidth
                                variant="outlined"
                                color="error"
                                sx={{ borderRadius: 2, justifyContent: 'flex-start', textTransform: 'none' }}
                            >
                                Remover Produto do Sistema
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>

                {/* DIALOG CONFIRMAÇÃO DE EXCLUSÃO */}
                <Dialog
                    open={Object.keys(this.state.deleteProduct).length > 0}
                    onClose={() => this.setState({ deleteProduct: {} })}
                    fullWidth
                    maxWidth="xs"
                    PaperProps={{ sx: { borderRadius: 3 } }}
                >
                    <DialogTitle sx={{ fontWeight: 'bold' }}>Confirmar Exclusão</DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="body2">
                            Deseja realmente remover o produto <strong>"{this.state.deleteProduct.name}"</strong>? Esta operação é irreversível.
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={() => this.setState({ deleteProduct: {} })} sx={{ textTransform: 'none' }}>
                            Cancelar
                        </Button>
                        <Button
                            startIcon={<DeleteIcon />}
                            onClick={this.handleDeleteProduct}
                            variant="contained"
                            color="error"
                            sx={{ borderRadius: 2, textTransform: 'none' }}
                        >
                            Excluir
                        </Button>
                    </DialogActions>
                </Dialog>

            </Box>
        );
    }
}

export default ListProducts;